/**
 * AXIS.MODEL.TS
 * Axis for a card
 */

import { getAxisImageUrl } from "@/utils/get-image-url"

export class Axis{
  color : string = "#eb5a46"
  id : string = ""
  image : boolean = false
  defaultImage : boolean = false
  name : any = {}

  constructor(axis: Partial<Axis> = {}){
    Object.assign(this, axis)
  }

  get picture():string{
    return getAxisImageUrl(String(this.image), this.defaultImage)
  }

}
